import { render, staticRenderFns } from "./ResolutionBuilder.vue?vue&type=template&id=a22b9e70&"
import script from "./ResolutionBuilder.vue?vue&type=script&lang=js&"
export * from "./ResolutionBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionBuilder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports